import React from 'react';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import { Endpoints } from 'UI/constants/endpoints';
import { UIStatus } from 'UI/constants/status';

import {
  getDeclinationCopyByStatus,
  resolveDeclinationStatus
} from '../DeclinationReasonsDrawer/DeclinationReasons.shared';
import {
  buildReasonDetailsPayload,
  getReasonDetailsFormValues,
  isRetryableStatusCode
} from '../DeclinationReasonsDrawer/DeclinationReasonsDrawer.utils';
import { DeclinationReasonsDrawerBase } from '../DeclinationReasonsDrawer/DeclinationReasonsDrawerBase';

export const SendoutDeclinationReasonsDrawer = ({
  initialValues,
  isSubmitting = false,
  onClose = () => {},
  onSaved = () => {},
  status
}) => {
  const declinationStatus = resolveDeclinationStatus(status?.id);

  const { state, refreshData } = useFetchWithStatusV2({
    endpoint: declinationStatus ? `${Endpoints.SendoutReasons}?statusId=${status?.id}` : null
  });

  if (!declinationStatus) return null;

  const { title } = getDeclinationCopyByStatus(declinationStatus);

  const reasons = state.status === UIStatus.Success ? state.results : [];
  const canRetryReasons =
    state.status === UIStatus.Error && isRetryableStatusCode(state.responseStatusCode);

  return (
    <DeclinationReasonsDrawerBase
      buildPayload={data => buildReasonDetailsPayload({ statusId: status?.id, formValues: data })}
      defaultValues={getReasonDetailsFormValues(initialValues)}
      hasReasonsError={state.status === UIStatus.Error || state.status === UIStatus.Empty}
      isLoadingReasons={state.status === UIStatus.Loading}
      isSubmitting={isSubmitting}
      onClose={onClose}
      onRetryReasons={canRetryReasons ? refreshData : undefined}
      onSaved={onSaved}
      reasons={reasons}
      title={title}
    />
  );
};
